import React, { Component } from 'react';
import styled from 'styled-components/macro'
import Ruler from './Ruler';
import Container from './Container';
import Glyph from './Glyph';

const StyledArtboard = styled.div`
  position: relative;
  padding: 20px;
  width: 100%;
  height: 100%;
  background: ${({theme}) => theme.bg};
  background-image: ${({theme}) => theme.grid};
  background-size: 20px 20px;
  overflow: hidden;
`

class Artboard extends Component {

  constructor(props){
    super(props);
    this.state = {
      blockClick: false,
    }
    this.artboardOnClick = this.artboardOnClick.bind(this);
    this.disableArtboardClick = this.disableArtboardClick.bind(this);
    this.enableArtboardClick = this.enableArtboardClick.bind(this);
  }

  disableArtboardClick(){
    this.setState({ blockClick: true });
  }

  enableArtboardClick(){
    this.setState({ blockClick: false });
  }

  artboardOnClick(){
    if(!this.state.blockClick){
      this.props.action.setActive(null);
    }
  }

  renderObjects(){
    let {
      objects,
      activeObject,
      action
    } = this.props;

    return objects.map( (object,index) => {
      let active = index === activeObject;
      return (
        <Container
          key={object.id}
          index={index}
          artboard={{
            disableClick: this.disableArtboardClick,
            enableClick: this.enableArtboardClick
          }}
          action={action}
          active={active}
          size={object.size}
          position={object.position}
        >{
          size => <Glyph renderAsSvg path={object.path} size={size} />
        }</Container>
      )
    })
  }

  render() {
    let {ruler, objects} = this.props;
    return (
      <StyledArtboard onClick={this.artboardOnClick} >
        {ruler && <Ruler objects={objects}/> }
        {this.renderObjects()}
      </StyledArtboard>
    )
  }
}

export default Artboard;
